import _extends from'@babel/runtime/helpers/extends';import _slicedToArray from'@babel/runtime/helpers/slicedToArray';import _objectWithoutProperties from'@babel/runtime/helpers/objectWithoutProperties';import React,{useState,useMemo}from'react';import PropTypes from'prop-types';import {useIntl}from'react-intl';import Joi from'joi';import CIAMLink from'../CIAMLink/CIAMLink.js';import {validIsRequired,validPassword}from'../../utils/validation.js';import muxCustomStyles from'../../customStyles/index.js';import FormTextInput from'../FormTextInput/FormTextInput.js';var PASSWORD_INPUT_VARIANTS = {
  CREATE: 'create',
  PROVIDE: 'provide',
  LOGIN: 'login',
  RESET: 'reset'
};
var PasswordInput = function PasswordInput(_ref) {
  var id = _ref.id,
    value = _ref.value,
    onChange = _ref.onChange,
    variant = _ref.variant,
    fieldOnly = _ref.fieldOnly,
    isEmbedded = _ref.isEmbedded,
    firstName = _ref.firstName,
    lastName = _ref.lastName,
    label = _ref.label,
    secondaryLabel = _ref.secondaryLabel,
    userName = _ref.userName,
    autoFocus = _ref.autoFocus,
    rest = _objectWithoutProperties(_ref, ["id", "value", "onChange", "variant", "fieldOnly", "isEmbedded", "firstName", "lastName", "label", "secondaryLabel", "userName", "autoFocus"]);
  var intl = useIntl();
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    confirmPassword = _useState2[0],
    setConfirmPassword = _useState2[1];
  var isAskingForCurrentPassword = [PASSWORD_INPUT_VARIANTS.PROVIDE, PASSWORD_INPUT_VARIANTS.LOGIN].includes(variant);
  var autoComplete = isAskingForCurrentPassword ? 'current-password' : 'new-password';
  var passwordLabel = 'shared.password.create';
  var combinedValidationList = useMemo(function () {
    return ['shared.password.checklist.minMax', 'shared.password.checklist.noSpace', 'shared.password.checklist.upperLowerCase', 'shared.password.checklist.number', 'shared.password.checklist.firstNameLastName', 'shared.password.checklist.userName', 'shared.password.checklist.invalidChar'];
  }, []);
  var defaultHidden = useMemo(function () {
    return ['shared.password.checklist.firstNameLastName', 'shared.password.checklist.invalidChar', 'shared.password.checklist.userName'];
  }, []);
  var confirmValidations = Joi.string().when(Joi.ref('.'), {
    then: Joi.string().equal(value)
  }).messages({
    'string.empty': 'shared.validation.empty',
    'any.only': 'shared.password.validation.confirmMatches'
  });
  var handleChange = function handleChange(newValue) {
    var passwordConfirmed = newValue === confirmPassword;
    onChange(newValue, passwordConfirmed);
  };
  var passwordCheckListInput = /*#__PURE__*/React.createElement(FormTextInput, _extends({
    isPassword: true,
    id: id,
    label: label || intl.formatMessage({
      id: "shared.password.".concat(variant)
    }),
    value: value,
    onChange: handleChange,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    customStyle: muxCustomStyles.textInput,
    validations: isAskingForCurrentPassword ? validIsRequired : validPassword({
      firstName: firstName,
      lastName: lastName,
      userName: userName
    }),
    validationsCombinedLabel: combinedValidationList === null || combinedValidationList === void 0 ? void 0 : combinedValidationList.map(function (item) {
      return intl.formatMessage({
        id: item
      });
    }),
    labelForValidation: intl.formatMessage({
      id: passwordLabel
    }),
    defaultHidden: defaultHidden === null || defaultHidden === void 0 ? void 0 : defaultHidden.map(function (item) {
      return intl.formatMessage({
        id: item
      });
    }),
    isCheckList: "true"
  }, rest));
  var passwordInput = /*#__PURE__*/React.createElement(FormTextInput, _extends({
    isPassword: true,
    id: id,
    label: label || intl.formatMessage({
      id: "shared.password.".concat(variant)
    }),
    value: value,
    onChange: handleChange,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    customStyle: muxCustomStyles.textInput,
    validations: isAskingForCurrentPassword ? validIsRequired : validPassword({
      firstName: firstName,
      lastName: lastName
    }),
    validationsCombinedLabel: intl.formatMessage({
      id: 'shared.password.validation.combined'
    }),
    labelForValidation: intl.formatMessage({
      id: passwordLabel
    })
  }, rest));
  if (fieldOnly) {
    return passwordInput;
  }
  var renderVariant = function renderVariant() {
    if (isEmbedded) {
      return null;
    }
    if (variant === PASSWORD_INPUT_VARIANTS.LOGIN) {
      return /*#__PURE__*/React.createElement(CIAMLink, {
        to: "/forgotpassword",
        analyticsData: {
          click: {
            linkName: intl.formatMessage({
              id: 'shared.password.forgotPassword'
            }),
            linkHref: '/forgotpassword'
          }
        }
      }, intl.formatMessage({
        id: 'shared.password.forgotPassword'
      }));
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isAskingForCurrentPassword ? passwordCheckListInput : passwordInput, renderVariant(), !isAskingForCurrentPassword && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormTextInput, _extends({
    isPassword: true,
    id: "".concat(id, "-confirm"),
    label: secondaryLabel || intl.formatMessage({
      id: 'shared.password.reenterPassword'
    }),
    value: confirmPassword,
    onChange: setConfirmPassword,
    autoComplete: autoComplete,
    customStyle: {
      rootStyle: {
        marginTop: '1rem',
        width: '100%'
      }
    },
    validations: confirmValidations,
    labelForValidation: intl.formatMessage({
      id: passwordLabel
    })
  }, rest))));
};
process.env.NODE_ENV !== "production" ? PasswordInput.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(Object.values(PASSWORD_INPUT_VARIANTS)),
  fieldOnly: PropTypes.bool,
  isEmbedded: PropTypes.bool,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  label: PropTypes.string,
  secondaryLabel: PropTypes.string,
  userName: PropTypes.string,
  autoFocus: PropTypes.bool
} : void 0;
PasswordInput.defaultProps = {
  variant: PASSWORD_INPUT_VARIANTS.PROVIDE,
  fieldOnly: false,
  isEmbedded: false,
  firstName: null,
  lastName: null,
  label: null,
  secondaryLabel: null,
  userName: null,
  autoFocus: false
};
var PasswordInput$1 = PasswordInput;export{PASSWORD_INPUT_VARIANTS,PasswordInput$1 as default};